import { Component, Directive, EventEmitter, Input, Output } from '@angular/core';
import { DatePicker } from 'primeng/datepicker';
import { PRIMENG_MODULES } from '../../shared/primeng-imports';

@Directive({
  selector: 'p-datepicker[appDashboardRangeTime]',
  standalone: true,
})
export class DashboardRangeTimeDirective {
  constructor(picker: DatePicker) {
    picker.toggleAMPMIfNotMinDate = (newPM: boolean) => {
      const value = picker.value;
      const activeDate = picker.isRangeSelection() ? (value?.[1] || value?.[0]) : value;
      const minDate = picker.minDate;
      const isMinDatePM = minDate && activeDate &&
        minDate.toDateString() === activeDate.toDateString() && minDate.getHours() >= 12;
      picker.pm = isMinDatePM ? true : newPM;
    };
  }
}

@Component({
  selector: 'app-dashboard-filters',
  templateUrl: './dashboard-filters.component.html',
  styleUrl: './dashboard-filters.component.scss',
  standalone:true,
  imports:[...PRIMENG_MODULES, DashboardRangeTimeDirective]
})
export class DashboardFiltersComponent {


  @Input() cameraList!: any;
  @Input() itemCodes!: any;
  @Input() filterOptions: any;
  @Input() userLists: any;
  @Output() filterAppliedEvent = new EventEmitter<{}>();
  @Output() clearFilterEvent = new EventEmitter();



  dateRange: (Date | null)[] | null = null;
  selectedCamera: string = '';
  selectedItemCode: string = '';
  selectedUser?: any=null;
  searchParcel: string = '';
  enableClearButton: boolean = true;
  applyBtnClicked: boolean = false;

  ngOnInit() {

  }

  applySearch() {
    this.applyBtnClicked = true;
    this.enableClearButton = false;
    let filterApplied = {
      selectedCamera: this.selectedCamera,
      selectedItemCode: this.selectedItemCode,
      dateRange: this.dateRange,
      searchParcel: (this.searchParcel.toUpperCase()).trim(),
      selectedUser: this.selectedUser,
    }
    this.filterAppliedEvent.emit(filterApplied);
  }
  clearSearch() {
    this.enableClearButton = true;

    this.selectedCamera = '';
    this.selectedItemCode = '';
    this.selectedUser = null;
    this.searchParcel = '';
    this.dateRange = null;
    if (this.applyBtnClicked)
      this.clearFilterEvent.emit();
    this.applyBtnClicked = false;
  };

  showClear() {
    return (!(this.selectedCamera != '' || this.selectedItemCode != '' || ((this.dateRange?.length ?? 0) > 0) || this.selectedUser != null  || this.searchParcel != ''))
  }
}
